import React from "react";
import { useParams } from "react-router-dom";
import { usePublicTodoEn1 } from "@/hooks/useProducts";
import PreviewPanel from "@/components/linktree/PreviewPanel";
import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import PageSpinner from "@/components/PageSpinner";

export default function LinkTree() {
  const { id } = useParams();
  const { data: config, isLoading, error } = usePublicTodoEn1(id);

  if (isLoading) {
    return <PageSpinner />;
  }

  if (error || !config) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <Card className="max-w-md w-full border-none shadow-xl rounded-3xl overflow-hidden">
          <div className="h-2 bg-red-500" />
          <CardContent className="pt-10 pb-8 text-center space-y-4">
            <div className="mx-auto w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-2">
              <AlertCircle className="w-10 h-10 text-red-500" />
            </div>
            <h1 className="text-2xl font-black text-slate-900">Configuración no disponible</h1>
            <p className="text-slate-600 px-4">Este dispositivo aún no ha sido configurado por su propietario o el ID es inválido.</p>
            <div className="pt-2">
              <Button
                variant="outline"
                className="w-full h-12 rounded-xl mt-4 border-slate-200"
                onClick={() => window.location.reload()}
              >
                Reintentar
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex justify-center bg-slate-100">
      <div className="w-full max-w-md shadow-2xl overflow-y-auto overflow-x-hidden">
        <PreviewPanel data={config} fullSize />
      </div>
    </div>
  );
}
